//SPOT.IM -- makes sure elements are loaded on page and then, depending on template, appends spot.im widget to right rail
function isITNLoaded(widget_loc, widget_order) {

    //testing do not run on mobile
    // var ismobile = $().isMobile(); 
    // if(ismobile==true){ return; }

    // if( widget_loc == "homepage" ){
    //     console.log("Disable Spot Ads for now");
    //     return;
    // }

    var target_el = '';
    if(widget_loc == "Other"){
        target_el = '.widget_slot:eq(2)';
    }else if(widget_loc == "homepage"){
        //var target_el = '[data-widget-title="Latest Polls"]';
        var target_column = '.beta';
        if(document.body.clientWidth < 768){ // smaller than ipad portrait
            target_column = '.alpha';
        }
        target_el = target_column + ' .spot-box'; //Added empty div to index template - Only page we needed additional markup
    }else if( widget_loc=='articles' ){
        target_el = '.widget_slot:eq(2)';

    }else{
        //else make widget_loc the target_el for custom places
        target_el = widget_loc;
    }


    if ( $(target_el).length>0 && !$(target_el).is("[data-no-ads]") ) {

        //console.log("ITN Loaded, Append SPOT.IM....");

        //temporary solution
        if(SITE_INFO['name'] == 'politics') {

            if(widget_order == "before"){
                // console.log('WIDGET LOC: ' + widget_loc);
                if(widget_loc == "homepage"){
                    // console.log('TARGET EL INSIDE IS HOMEPAGE CHECK: ' + target_el);
                    // style="min-height: 750px"
                    // data-page-type="homepage" removed
                    $(target_el).append('<div class="spot-im-widget-header" style="font-size:13px; background-color:#d30015; color: #FFFFFF;padding: 15px 15px;width: auto;font-weight: bold;margin-bottom: 0px;">Popular in the Community</div><div  data-spotim-module="pitc" data-vertical-view="true" > </div>');

                    var social_side_rail = document.createElement("script");
                    social_side_rail.type = "text/javascript";
                    //social_side_rail.src = "https://recirculation.spot.im/spot/" + SITE_INFO['spot_production_id'] + "/siderail";
                    social_side_rail.src = "https://launcher.spot.im/spot/" + SITE_INFO['spot_production_id'];
                    social_side_rail.async = true;
                    social_side_rail.setAttribute("data-spotim-module", "spotim-launcher");
                    social_side_rail.setAttribute("data-post-id", "homepage");
                    social_side_rail.setAttribute("data-spotim-autorun", "false");
                    //$(social_side_rail).appendTo("body");
                    $(target_el).append(social_side_rail);

                }else{

                    // style="min-height: 750px" data-vertical-view="true"
                    $(target_el).after('<div class="spot-im-widget-header" style="font-size:13px; background-color:#d30015; color: #FFFFFF;padding: 15px 15px;width: auto;font-weight: bold;margin-bottom: 0px;">Popular in the Community</div><div  data-spotim-module="pitc" data-vertical-view="true" ></div>');


                    var data_post_id = $('body').attr('class');

                    if(typeof window.__OW_CONFIG__ == 'undefined'){ // if the SPOT>IM library is not loaded then load it

                        var social_side_rail = document.createElement("script");
                        social_side_rail.type = "text/javascript";
                        social_side_rail.src = "https://launcher.spot.im/spot/" + SITE_INFO['spot_production_id'];
                        social_side_rail.async = true;
                        social_side_rail.setAttribute("data-spotim-module", "spotim-launcher");
                        social_side_rail.setAttribute("data-post-id", data_post_id );
                        social_side_rail.setAttribute("data-spotim-autorun", "false");
                        //$(social_side_rail).appendTo("body");
                        $(target_el).append(social_side_rail);

                    }


                }


            }else{

                // data-vertical-view="true"
                $(target_el).after('<div class="spot-im-widget-header" style="font-size:13px; background-color:#d30015; color: #FFFFFF;padding: 15px 15px;width: auto;font-weight: bold;margin-bottom: 0px;">Popular in the Community</div><div data-spotim-module="pitc" data-vertical-view="true" ></div>');

                var data_post_id = $('body').attr('class');

                if(typeof window.__OW_CONFIG__ == 'undefined'){

                    var social_side_rail = document.createElement("script");
                    social_side_rail.type = "text/javascript";
                    social_side_rail.src = "https://launcher.spot.im/spot/" + SITE_INFO['spot_production_id'];
                    social_side_rail.async = true;
                    social_side_rail.setAttribute("data-spotim-module", "spotim-launcher");
                    social_side_rail.setAttribute("data-post-id", data_post_id );
                    social_side_rail.setAttribute("data-spotim-autorun", "false");
                    //$(social_side_rail).appendTo("body");
                    $(target_el).append(social_side_rail);

                }

            }

        } else {
            if(widget_order == "before"){
                //console.log('WIDGET LOC: ' + widget_loc);
                if(widget_loc == "homepage"){
                    //console.log('TARGET EL INSIDE IS HOMEPAGE CHECK: ' + target_el);
                    $(target_el).append('<div class="spot-im-widget-header" style="font-size:13px; background-color:'+site_color+'; color: #FFFFFF;padding: 15px 15px;width: auto;font-weight: bold;margin-bottom: 0px;">Popular in the Community</div><div data-spotim-module="pitc" data-vertical-view="true" data-page-type="homepage"> </div>');

                    var social_side_rail = document.createElement("script");
                    social_side_rail.type = "text/javascript";
                    //social_side_rail.src = "https://recirculation.spot.im/spot/" + SITE_INFO['spot_production_id'] + "/siderail";
                    social_side_rail.src = "https://launcher.spot.im/spot/" + SITE_INFO['spot_production_id'];
                    social_side_rail.async = true;
                    social_side_rail.setAttribute("data-spotim-module", "spotim-launcher");
                    social_side_rail.setAttribute("data-post-id", "homepage");
                    social_side_rail.setAttribute("data-spotim-autorun", "false");
                    //$(social_side_rail).appendTo("body");
                    $(target_el).append(social_side_rail);

                }else{

                    $(target_el).after('<div class="spot-im-widget-header" style="font-size:13px; background-color:'+ site_color +'; color: #FFFFFF;padding: 15px 15px;width: auto;font-weight: bold;margin-bottom: 0px;">Popular in the Community</div><div data-spotim-module="pitc" data-vertical-view="true"></div>');

                    var data_post_id = $('body').attr('class');

                    if(typeof window.__OW_CONFIG__ == 'undefined'){

                        var social_side_rail = document.createElement("script");
                        social_side_rail.type = "text/javascript";
                        social_side_rail.src = "https://launcher.spot.im/spot/" + SITE_INFO['spot_production_id'];
                        social_side_rail.async = true;
                        social_side_rail.setAttribute("data-spotim-module", "spotim-launcher");
                        social_side_rail.setAttribute("data-post-id", data_post_id );
                        social_side_rail.setAttribute("data-spotim-autorun", "false");
                        //$(social_side_rail).appendTo("body");
                        $(target_el).append(social_side_rail);

                    }

                }


            }else{

                $(target_el).after('<div class="spot-im-widget-header" style="font-size:13px; background-color:'+ site_color +'; color: #FFFFFF;padding: 15px 15px;width: auto;font-weight: bold;margin-bottom: 0px;">Popular in the Community</div><div data-spotim-module="pitc" data-vertical-view="true"></div>');

                var data_post_id = $('body').attr('class');

                if(typeof window.__OW_CONFIG__ == 'undefined'){

                    var social_side_rail = document.createElement("script");
                    social_side_rail.type = "text/javascript";
                    social_side_rail.src = "https://launcher.spot.im/spot/" + SITE_INFO['spot_production_id'];
                    social_side_rail.async = true;
                    social_side_rail.setAttribute("data-spotim-module", "spotim-launcher");
                    social_side_rail.setAttribute("data-post-id", data_post_id );
                    social_side_rail.setAttribute("data-spotim-autorun", "false");
                    //$(social_side_rail).appendTo("body");
                    $(target_el).append(social_side_rail);

                }

            }
        }


    } else {
        //check in 500 ms
        setTimeout(isITNLoaded, 500, widget_loc, widget_order);
    }

}

function init_spot_right_rail()
{
    var widget_loc = '';
    var widget_order = '';

    if( $("body.entry").length>0 || $("body.author").length>0 || $("body.cartoon").length>0 || $("body.search").length>0 || $("body.story-stream").length>0 ){

        //Check, Re-Check if elements exist until they do then append spot widget to right rail
        widget_loc = 'Other';
        widget_order = 'before';

        isITNLoaded(widget_loc, widget_order);

    }else if( $("body.home").length>0  ){ //&& $("body").hasClass("spot-home")

        //Check, Re-Check if elements exist until they do then append spot widget to right rail
        widget_loc = 'homepage';
        widget_order = 'before';

        isITNLoaded(widget_loc, widget_order);
    }else if( $("body.article").length>0 ){

        widget_loc = 'articles';
        widget_order = 'after';
        isITNLoaded(widget_loc, widget_order);

    }else if( $("body.polls").length>0 || $("body.live_results").length>0 ){

        widget_order = 'before';
        isITNLoaded(".widget_slot:eq(1)", widget_order);

    }else if( $("body.video").length>0 ){
        //Check, Re-Check if elements exist until they do then append spot widget to right rail
        widget_loc = 'Other';
        widget_order = 'after';

        isITNLoaded(widget_loc, widget_order);
    }
}

export default init_spot_right_rail;